import React, { useState, useEffect } from 'react';
import { useStyles } from "../styles/styles";
import { getDecimal } from "../global/utils";
import { dateIso2Us } from "../global/dateUtils";
import Grid from '@mui/material/Grid';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Typography from "@mui/material/Typography";
import ListItemText from '@mui/material/ListItemText';
import FormControlLabel from '@mui/material/FormControlLabel';
import useMediaQuery from "@mui/material/useMediaQuery";
import Checkbox from "@mui/material/Checkbox";

const BondList = (props) => {
    const bonds = props.bonds;
    const balance = props.balance;
    const setPayIneligible = props.setPayIneligible;
    const trafficSchoolSelections = props.trafficSchoolSelections;
    const balBondId = props.balBondId;
    const onSelect = props.onSelect;
    const classes = useStyles;
    const [bondId, setBondId] = useState(balance?.bondId);
    const isMobile = useMediaQuery(theme => theme.breakpoints.down('sm'));

    const handleBondClick = (bond, checked) => {
        setBondId(checked ? bond?.bondId : null);
        onSelect(balance, checked ? bond?.bondId : null, checked ? bond?.bondAmount : null);
    }

    const getBondAmount =  (bondIdIn) => {
        const filteredBonds = bonds.filter(b => b.bondId === bondIdIn);
        if (filteredBonds && filteredBonds.length > 0) return filteredBonds[0].bondAmount;
        return 0;
    }

    useEffect(() => {
        balance.bondId = bondId;
        balance.bondAmt = bondId ? getBondAmount(bondId) : null;
    }, [bondId])

    useEffect(() => {
        if (trafficSchoolSelections && trafficSchoolSelections[balance.refId]) {
            setBondId(null);
        }
    }, [trafficSchoolSelections])

    useEffect(() => {
        if (!balBondId) {
            setBondId(null);
        }
    }, [balBondId]);

    return (
        <>
            <List sx={{...classes.list, maxHeight: '100%', marginLeft: '1rem'}} >
                <ListItem alignItems='flex-start' sx={classes.listPadding}>
                    <ListItemText
                        sx={classes.listText}
                        primary={
                            <Grid
                                container
                                spacing={1}
                                alignItems="top"
                            >
                                <Grid item xs={12}><Typography variant='subtitle2' sx={classes.title}>Options(s)</Typography></Grid>
                                <Grid item xs={3}>&nbsp;</Grid>
                                <Grid item xs={6} sx={{ display: 'flex', justifyContent: isMobile ? 'center' : 'flex-start', fontWeight: 'bold' }}>Type</Grid>
                                <Grid item xs={3} sx={{paddingLeft: '1rem', fontWeight: 'bold'}}>Amount</Grid>
                            </Grid>
                        }
                        primaryTypographyProps={{
                            component: 'span',
                            color: 'textPrimary',
                            sx: {fontSize: '.9rem', lineHeight: '.7rem'},
                        }}
                    />
                </ListItem>
                    <>
                        { bonds && bonds.length > 0 && bonds.map((bond) => {
                            return (
                                <ListItem alignItems='flex-start' disableGutters sx={{paddingTop: '0', paddingBottom: '0'}}>
                                    <ListItemText
                                        sx={classes.listText}
                                        primary={
                                            <Grid
                                                container
                                                spacing={1}
                                                alignItems="top"
                                            >
                                                <Grid item xs={3}>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                name="pay"
                                                                color='primary'
                                                                size='small'
                                                                sx={{marginLeft: '1rem', paddingTop: '0'}}
                                                                checked={bondId === bond?.bondId}
                                                                onChange={(e) => {handleBondClick(bond, e.target.checked)}}
                                                                inputProps={{'aria-label': `Select bond option ${bond.bondType}`}}
                                                            />
                                                        }
                                                        label=''
                                                        aria-label='select bond'
                                                        sx={{paddingLeft: '0', paddingTop: '0'}}
                                                    />
                                                </Grid>
                                                <Grid item xs={6} sx={{ display: 'flex', justifyContent: isMobile ? 'center' : 'flex-start' }}>{"Post a Bond - "}{`${bond.bondType} ${bond.ineligibleUntilDate ? dateIso2Us(bond.ineligibleUntilDate) : ''}`}</Grid>
                                                <Grid item xs={3} sx={{textAlign: 'right', paddingRight: {xs: '0', sm: '14%', lg: '20%'}}}>{getDecimal(bond.bondAmount)}</Grid>
                                            </Grid>
                                        }
                                        primaryTypographyProps={{
                                            component: 'span',
                                            color: 'textPrimary',
                                            sx: {fontSize: '.9rem', paddingLeft: '.2rem'}
                                        }}
                                    />
                                </ListItem>
                            );
                        })}
                    </>
            </List>
        </>
    );
}

export default BondList;
